// extracted by mini-css-extract-plugin
export default {"Stats":"ProfileStats_Stats__6JDNN","StatsHeader":"ProfileStats_StatsHeader__Ko9NF","Separator":"ProfileStats_Separator__v1FVr"};